import classNames from 'classnames';

import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

import type {DistributionBarSection} from './types';

import styles from './distribution-bar.module.css';

interface Props {
    sections: DistributionBarSection[];
    widths: number[];
    borderVariant?: 'light' | 'dark';
    showAsPercentage?: boolean;
}

export function MiniProportionalMode(props: Props) {
    const containerClasses = classNames(styles['distribution-bar-container--mini'], {
        [styles['distribution-bar-container--dark']]: props.borderVariant === 'dark',
    });

    return (
        <Stack spacing={8}>
            <Stack isHorizontal={true}>
                {props.sections.map((section, index) => (
                    <div
                        key={section.label}
                        style={{width: `${props.widths[index]}%`}}
                        className='flex justify-center'
                        onClick={section.onClick}
                    >
                        <Body isBold={true} size='large' color='dark'>
                            {props.showAsPercentage ? `${section.value}%` : section.value}
                        </Body>
                    </div>
                ))}
            </Stack>
            <div className={containerClasses}>
                {props.sections.map((section, index) => (
                    <div
                        key={section.label}
                        style={{width: `${props.widths[index]}%`, backgroundColor: section.color}}
                        className={classNames(styles['bar-section'], styles['bar-section--mini'], {
                            [styles['bar-section--hoverable']]: Boolean(section.onClick),
                        })}
                        onClick={section.onClick}
                    />
                ))}
            </div>
        </Stack>
    );
}
